import { Link } from '@ui-kit';
import User from '@ui-kit/icons/user-gray700.svg';
//import IllustrationGray from '@ui-kit/icons/image-gray700.svg';
import EditIcon from '@ui-kit/icons/edit-3-gray700.svg';

import {  
  ADMIN_USER_SETTINGS_URL,
  ADMIN_USERS_URL,
  ADMIN_MANAGEMENT_SETTINGS_URL,
} from "@app/routes";

export const MENU_LIST = [
  {component: (
      <Link to={ADMIN_USER_SETTINGS_URL} theme="text">
        View profile
      </Link>
    ),
    icon: User,
    isDivider: true
  },
  {/*component: (
    <Link to={ADMIN_USER_BILLS_URL} theme="text">
      My bills
    </Link>
    ),
    icon: FileIcon,
    isDivider: true
  */}
];

export const MENU_LIST_ADMIN = [
  {component: (
      <Link to={ADMIN_USER_SETTINGS_URL} theme="text">
        View profile
      </Link>
    ),
    icon: User,
    isDivider: true
  },
  {component: (
      <Link to={ADMIN_USERS_URL} theme="text">
        Users
      </Link>
    ),
    icon: User,
  },
  {component: (
    <Link to={ADMIN_MANAGEMENT_SETTINGS_URL} theme="text">
      Admin settings
    </Link>
  ),
  icon: EditIcon,
}
];

  
export const MENU_LANG_LIST = [
  {component: (
    <div id="en" className="link">
      English
    </div>
  )},
  {component: (
    <div id="ru" className="link">
      Russian
    </div>
  )},
];
